import { gql } from "@apollo/client"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import {
  CreatePaymentMethodStripeAchInput,
  CreatePaymentMethodStripeAchPayload,
} from "@oysterhr/schema"

export const useCreateStripeAch = (
  options?: InjectedOptions<
    { createPaymentMethodStripeAch: CreatePaymentMethodStripeAchPayload },
    CreatePaymentMethodStripeAchInput
  >,
) =>
  useMutation(
    gql`
      mutation PaymentMethodsCompanyCreatePaymentMethodStripeAch(
        $ownerId: ID!
        $stripeBankToken: String!
        $accountNumber: String!
        $routingNumber: String!
        $accountHolderName: String!
      ) {
        createPaymentMethodStripeAch(
          input: {
            ownerId: $ownerId
            stripeBankToken: $stripeBankToken
            accountNumber: $accountNumber
            routingNumber: $routingNumber
            accountHolderName: $accountHolderName
          }
        ) {
          paymentMethod {
            ... on PaymentMethodStripeAch {
              id
              accountNumber
              routingNumber
              state
              currencyCode
            }
          }
          errors
        }
      }
    `,
    options,
  )
